import styled, { keyframes } from 'styled-components';
import React, {useState, useEffect} from 'react';
import AnchorLink from "react-anchor-link-smooth-scroll";

// import TopBackgroundVideo from '../../assets/video/top_background.mov'
import HeaderLogo from '../../assets/image/icon/header_logo.png';
import TopLogo from '../../assets/image/icon/top_logo.png'
import InstagramIcon from '../../assets/image/icon/instagram.png';
import TiktokIcon from '../../assets/image/icon/tiktok.png';
import TwitterIcon from '../../assets/image/icon/twitter.png';
import YouTubeIcon from '../../assets/image/icon/youtube.png';
import MainVisual1 from '../../assets/image/top/1.jpg';
import MainVisual2 from '../../assets/image/top/2.jpg';
import MainVisual3 from '../../assets/image/top/3.jpg';
import MainVisual4 from '../../assets/image/top/4.jpg';
import MainVisual5 from '../../assets/image/top/5.jpg';
import MainVisual6 from '../../assets/image/top/6.jpg';
import MainVisual7 from '../../assets/image/top/7.jpg';
import MainVisual8 from '../../assets/image/top/8.jpg';
import TapButtonImage from '../../assets/image/icon/tap_button.png';

const TopSection = styled.section`
  header {
    position: fixed;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 550px;
    height: 6vh;
    z-index: 11;
    img {
      width: 160px;
      z-index: 11;
    }
  }

  .top-container {
    position: relative;
  }

  .openbtn{
    position: fixed;
    cursor: pointer;
    width: 50px;
    height:50px;
    border-radius: 5px;
    z-index: 12;
    margin: 3px 0 0 5px;
  }

  .openbtn span{
    display: inline-block;
    transition: all .4s;
    position: absolute;
    left: 14px;
    height: 1px;
    border-radius: 2px;
    background: #000;
    width: 45%;
  }

  .openbtn span:nth-of-type(1) {
    top:15px; 
  }

  .openbtn span:nth-of-type(2) {
    top:23px;
  }

  .openbtn span:nth-of-type(3) {
    top:31px;
  }

  .openbtn.is-open span:nth-of-type(1) {
    top: 18px;
    left: 18px;
    transform: translateY(6px) rotate(-45deg);
    width: 40%;
  }

  .openbtn.is-open span:nth-of-type(2) {
    opacity: 0;
  }

  .openbtn.is-open span:nth-of-type(3){
    top: 30px;
    left: 18px;
    transform: translateY(-6px) rotate(45deg);
    width: 40%;
  }
`

const BackgroundImage = styled.img`
  width: 100%;
  height: 100dvh;
  object-fit: cover;
`

// 上下にふわふわするアニメーションを定義
const floatAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px); /* 上に10px移動 */
  }
  100% {
    transform: translateY(0); /* 元に戻る */
  }
`;

const ChevronWrapper = styled.div`
  position: absolute;
  bottom: 8dvh;
  left: calc(50% - 0.55rem);
  animation: ${floatAnimation} 2s ease-in-out infinite; /* 上下アニメーション */
  transform: translateX(-50%); /* 水平方向に中央揃え */
`;

const Chevron = styled.span`
  display: inline-block;
  vertical-align: middle;
  color: ${(props) => (props.active ? '#fff' : '#333')}; // activeがtrueのときは白、それ以外は黒
  line-height: 1;
  position: relative;
  width: 1em;
  height: 1em;
  transform: rotate(135deg); 

  &::before, &::after {
    content: '';
    position: absolute;
    background: currentColor;
    border-radius: 0.1em;
  }

  &::before {
    top: 0;
    left: 0;
    right: 0;
    height: 0.2em;
  }

  &::after {
    top: 0;
    right: 0;
    bottom: 0;
    width: 0.2em;
  }
`;

const TapButtonWrapper = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 16dvh;
`;

const TapButton = styled.img`
  width: 60px;
  height: 60px;
  cursor: pointer;
`;

const SectionTop = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const [isWhiteChevron, setIsWhiteChevron] = useState(false); ;

  const images = [MainVisual1, MainVisual2, MainVisual3, MainVisual4, MainVisual5, MainVisual6, MainVisual7, MainVisual8];

  useEffect(() => {
    if (isOpen) {
      // メニューが開いたら縦スクロールを制御するための処理
      document.body.classList.add('no-scroll');
    } else {
      // メニューが閉じたら縦スクロール制御を解除するための処理
      document.body.classList.remove('no-scroll');
    }
  }, [isOpen]);

  const handleClick = () => {
    setIsOpen(!isOpen);
  }

  const handleBackgroundImageClick = () => {
    setCurrentImageIndex((prevIndex) => {
      const nextIndex = (prevIndex + 1) % images.length;

      if ([1, 6, 7].includes(nextIndex)) {
        setIsWhiteChevron(true);
      } else {
        setIsWhiteChevron(false);
      }

      return nextIndex;
    });
  };

  return (
    <TopSection>
      <header>
        <img src={HeaderLogo} alt="PLACOLE & DRESSY"/>
        {isOpen && (
          <HamburgerMenu onClick={() => handleClick()} />
        )}
      </header>
      <div className={`openbtn ${isOpen ? 'is-open' : ''}`} onClick={handleClick}>
        <span></span><span></span><span></span>
      </div>
      <div className='top-container' onClick={handleBackgroundImageClick}>
        <BackgroundImage src={images[currentImageIndex]} alt="PLACOLE & DRESSY" />
        <ChevronWrapper>
          <Chevron active={isWhiteChevron}></Chevron>
        </ChevronWrapper>
        <TapButtonWrapper>
          <TapButton src={TapButtonImage} alt="TAP" />
        </TapButtonWrapper>
      </div>
    </TopSection>
  )
}

export default SectionTop;

const HamburgerMenuSection = styled.section`
  position: absolute;
  top: 0;
  background-color: #fff;
  width: 100%;
  height: 100vh;
  z-index: 10;
  max-width: 550px;
  animation: fade-in 0.5s ease;

  @keyframes fade-in {
    0% {
      opacity: 0;
      transform: translateY(-20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  nav {
    height: 70vh;
    margin-top: 10vh;

    .menu-button-wrapper {
      padding: 0 10%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
  
      a {
        text-decoration: none;
        color: black;
        padding: 10px 0;
        font-weight: 500;
        margin: 10px 0;
        display: block;
      }
    }
  }

  .sns-button-wrapper {
    margin-top: 6vh;

    ul {
      display: flex;
      justify-content: space-between;
      width: 60%;
      margin: 0 auto;
    }

    a {
      display: flex;
      justify-content: center;
    }

    img {
      width: 70%;
    }
  }
`


const HamburgerMenu = (props) => {
  return (
    <HamburgerMenuSection isOpen={props.isOpen}>
      <nav>
        <ul className="menu-button-wrapper">
          <AnchorLink href="#brand-story" onClick={props.onClick}>ブランドストーリー</AnchorLink>
          <AnchorLink href="#collaboration-dress" onClick={props.onClick}>コラボドレス</AnchorLink>
          <AnchorLink href="#original-dress" onClick={props.onClick}>オリジナルドレス</AnchorLink>
          <AnchorLink href="#collaboration-accessory" onClick={props.onClick}>コラボリング・アクセサリー</AnchorLink>
          <AnchorLink href="#life-style-item" onClick={props.onClick}>オリジナルアイテム</AnchorLink>
          <AnchorLink href="#shop-list" onClick={props.onClick}>ショップリスト</AnchorLink>
          <AnchorLink href="#produce-cafe" onClick={props.onClick}>プロデュースカフェ</AnchorLink>
        </ul>
      </nav>
      <div className="sns-button-wrapper">
        <ul>
          <li><a target="_blank" href="https://instagram.com/placole_dressy" rel="noopener noreferrer"><img src={InstagramIcon} alt="Instagram" /></a></li>
          <li><a target="_blank" href="https://www.tiktok.com/@placole_dressy" rel="noopener noreferrer"><img src={TiktokIcon} alt="TikTok" /></a></li>
          <li><a target="_blank" href="https://twitter.com/placole_dressy" rel="noopener noreferrer"><img src={TwitterIcon} alt="Twitter" /></a></li>
          <li><a target="_blank" href="https://www.youtube.com/@placoledressychannel7590" rel="noopener noreferrer"><img src={YouTubeIcon} alt="YouTube" /></a></li>
        </ul>
      </div>
    </HamburgerMenuSection>
  )
}